<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        v-if="puedoEditar() && itemSeleccionado.estado.codigo === 'abierto'"
        @click="editar()"
        class="ma-0"
      >
        <v-icon
          small
          color="blue-grey"
        >edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-spinner v-if="cargando"></v-spinner>
    <v-card-text
      style="max-height: 100%;"
      v-else
    >
      <v-alert
        v-model="alerta.mostrar"
        dismissible
        :type="alerta.tipo"
      >
        {{ alerta.mensaje }}
      </v-alert>

      <v-container
        grid-list-md
        fluid
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.emitido_por_obra_social_id"
              :items="info.obrasSociales"
              item-text="nombre"
              item-value="id"
              label="A la orden de"
              @change="alCambiarObraSocial"
              v-validate="{ required: true }"
              :data-vv-name="'emitido_por_obra_social_id'"
              :error-messages="errors.collect('emitido_por_obra_social_id')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha"
              label="Fecha"
              v-validate="{ required: true }"
              :data-vv-name="'fecha'"
              :error-messages="errors.collect('fecha')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="number"
              prefix="$"
              v-model="itemSeleccionado.importe"
              label="Importe"
              v-validate="{ required: true }"
              :data-vv-name="'importe'"
              :error-messages="errors.collect('importe')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
              :hint="$options.filters.currency(itemSeleccionado.importe)"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              :rows="2"
              v-model="itemSeleccionado.concepto"
              label="Concepto"
              v-validate="{ required: true }"
              :data-vv-name="'concepto'"
              :error-messages="errors.collect('concepto')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-subheader xs12>COMPROBANTES A CANCELAR</v-subheader>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="criterios.obra_social_id"
              :items="info.obrasSociales"
              item-text="nombre"
              item-value="id"
              label="Obra social"
              v-validate="{ required: true }"
              :data-vv-name="'criterios.obra_social_id'"
              :error-messages="errors.collect('criterios.obra_social_id')"
              data-vv-validate-on="blur"
              :read-only="true"
              :disabled="true"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="criterios.obra_social_plan_id"
              :items="obraSocialPlanes"
              item-text="nombre"
              item-value="id"
              label="Plan"
              :data-vv-name="'criterios.obra_social_plan_id'"
              :error-messages="errors.collect('criterios.obra_social_plan_id')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs12
            sm2
          >
            <v-text-field
              type="number"
              v-model="criterios.numero_comprobante"
              label="Nro. comprobante"
              :data-vv-name="'criterios.numero_comprobante'"
              :error-messages="errors.collect('criterios.numero_comprobante')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm2
            align-center
          >
            <v-btn
              small
              :loading="criterios.buscando"
              :disabled="criterios.buscando || soloLectura || !puedoBuscar"
              color="primary"
              @click="buscarComprobantesParaCancelar"
            >
              Buscar
            </v-btn>
          </v-flex>
        </v-layout>
        <v-data-table
          v-model="tablaComprobantes.seleccionados"
          select-all
          :headers="tablaComprobantes.headers"
          :items="tablaComprobantes.items"
          :total-items="tablaComprobantes.totalItems"
          :loading="tablaComprobantes.cargando"
          :pagination.sync="tablaComprobantes.paginacion"
          :rows-per-page-items="tablaComprobantes.itemsPorPagina"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="tablaComprobantes.cargando"
          ></v-progress-linear>
          <template v-slot:headers="props">
            <tr>
              <th>
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.stop="toggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column']"
              >

                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>
                <v-checkbox
                  v-model="
              props.selected"
                  primary
                  hide-details
                  @change="asignarImporteDestinado(props.item,!props.selected)"
                >
                </v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.fecha | formatoFecha }}</td>
              <td class="text-xs-left ">{{ props.item | cabeceraComprobante }}</td>
              <td class="text-xs-right ">{{ props.item.importe_facturado | currency }}</td>
              <td class="text-xs-right ">{{ props.item.importe_facturado - props.item.importe_cobrado | currency}}</td>
              <td class="text-xs-right ">{{ props.item.concepto_descripcion }}</td>
              <td class="justify-center align-center">
                <v-text-field
                  prefix="$"
                  type="number"
                  v-model="props.item.importe_destinado"
                  :disabled="soloLectura || !props.selected"
                  :readonly="props.item.tipo_comprobante.codigo === 'NC'"
                  class="currency body-1"
                  @change="calcularImporteItem(props.item)"
                  data-vv-validate-on="blur"
                  :hint="$options.filters.currency(props.item.importe_destinado)"
                  persistent-hint
                ></v-text-field>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <td colspan="6"></td>
            <td class="justify-center align-center">
              <p class="currency body-1 custom font-weight-bold text-xs-right">{{ calcularImporte() | currency }}</p>
              <!--v-text-field
                id="txtTotal"
                prefix="$"
                type="number"
                :value="calcularImporte()"
                :readonly="true"
                class="currency body-1 custom font-weight-bold"
              ></v-text-field-->
            </td>
            <!--td class="text-xs-right caption">{{ calcularImporte() | currency }}</td-->
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedoGuardar"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import { formatoFecha, nombreCentro, cabeceraComprobante } from '@/helpers/filtros'
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'ReciboFormulario',
  mixins: [abmFormularioMixin],
  filters: {
    formatoFecha,
    nombreCentro,
    cabeceraComprobante
  },
  computed: {
    obraSocialPlanes () {
      if (this.obraSocialSeleccionada) {
        return this.obraSocialSeleccionada.planes
      } else {
        return []
      }
    },

    obrasSociales () {
      return _.filter(this.info.comprobanteReceptores, item => {
        return item.tipo === 'O'
      })
    },
    puedoBuscar () {
      return this.obraSocialSeleccionada
    },
    puedoGuardar () {
      let importeCalculado = Number(this.importeCalculado)
      let importeSeleccionado = Number(this.itemSeleccionado.importe)

      return this.puedo(this.operacion) &&
        !this.soloLectura && this.puedoBuscar &&
        importeSeleccionado > 0 &&
        importeCalculado === importeSeleccionado
    }

  },
  data () {
    return {
      montarMixin: false,
      info: {
        obrasSociales: []
      },
      obraSocialSeleccionada: null,
      criterios: {
        obra_social_id: null,
        obra_social_plan_id: null,
        numero_comprobante: null
      },
      tablaComprobantes: {
        items: [],
        headers: [
          { text: 'Fecha', value: 'fecha', sortable: true },
          { text: 'Tipo/Letra/Pto.Vta./Nro', value: 'tipo_comprobante_id', sortable: false },
          { text: 'Importe facturado', value: 'importe_facturado', sortable: false, align: 'right' },
          { text: 'Saldo', value: 'importe_facturado', sortable: false, align: 'right' },
          { text: 'Concepto', value: 'concepto_descripcion', sortable: false },
          { text: 'Acciones', value: 'id', sortable: false }
        ],
        paginacion: {},
        totalItems: 0,
        seleccionados: [],
        cargando: false,
        itemsPorPagina: [20, 50, 100]
      },
      importeCalculado: 0

    }
  },
  mounted () {
    let vm = this

    if (vm.item.id > 0) {
      vm.modeloApi.obtener(vm.item.id).then(data => {
        data.importe = data.importe.replace('.', ',')
        vm.itemSeleccionado = _.cloneDeep(data)

        vm.cargarInfo()
      })
    } else {
      vm.cargarInfo()
    }
  },
  methods: {
    cargarInfo () {
      let vm = this

      let cargaOrigen = 'inicial'

      let dataCombos = {
        obrasSociales: {
          itemVacio: true,
          relaciones: ['planes']
        }
      }

      if (vm.item.id > 0) {
        cargaOrigen = 'edicion'
      }

      vm.cargarCombos(dataCombos, cargaOrigen)
    },
    calcularImporteItem (item) {
      let importeDestinado = Number(item.importe_destinado)
      let saldo = Number(item.importe_facturado) - Number(item.importe_cobrado)

      if (importeDestinado > saldo) {
        item.importe_destinado = saldo.toFixed(2)
      }
    },
    calcularImporte () {
      let vm = this
      let importe = 0
      _.forEach(this.tablaComprobantes.seleccionados, function (item) {
        importe += (Number(item.importe_destinado) * (item.tipo_comprobante.codigo === 'NC' ? -1 : 1))
      })

      vm.importeCalculado = importe.toFixed(2)
      // return String(importe).replace(',', '.')
      return vm.importeCalculado
    },

    alCambiarObraSocial () {
      let vm = this
      vm.obraSocialSeleccionada = _.find(vm.info.obrasSociales, {
        id: vm.itemSeleccionado.emitido_por_obra_social_id
      })
      vm.criterios.obra_social_id = vm.obraSocialSeleccionada ? vm.obraSocialSeleccionada.id : null
      vm.criterios.obra_social_plan_id = null
      vm.errors.clear()
    },

    cargarCombos (dataCombos, cargaOrigen) {
      let vm = this
      Combo.listado(dataCombos).then(
        data => {
          vm.info = _.assign(vm.info, data)

          switch (cargaOrigen) {
            case 'edicion':
              vm.alCambiarObraSocial()
              break
          }

          vm.cargando = false
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },

    buscarComprobantesParaCancelar () {
      let vm = this
      if (!vm.tablaComprobantes.cargando) {
        vm.tablaComprobantes.cargando = true
        vm.modeloApi.buscarComprobantesParaCancelar(vm.criterios).then(data => {
          data = _.forEach(data, (item) => {
            item.importe_destinado = 0
          })
          Vue.set(vm.tablaComprobantes, 'items', data)

          vm.tablaComprobantes.totalItems = data.lenght
          vm.tablaComprobantes.cargando = false
        }, error => {
          if (error.type === 422) {
            vm.mostrarErroresEnCampos(error)
          } else {
            vm.mostrarError(error)
          }

          vm.tablaComprobantes.cargando = false
        })
      }
    },

    asignarImporteDestinado (item, seleccionado) {
      if (seleccionado) {
        let saldo = Number(item.importe_facturado) - Number(item.importe_cobrado)
        item.importe_destinado = saldo.toFixed(2)
      } else {
        item.importe_destinado = Number(0).toFixed(2)
      }
    },

    antesDeGuardar () {
      let vm = this
      vm.itemSeleccionado.comprobantes = _.clone(vm.tablaComprobantes.seleccionados)
    },

    toggleAll () {
      if (this.tablaComprobantes.seleccionados.length) {
        this.tablaComprobantes.seleccionados = []
        _.forEach(this.tablaComprobantes.items, (item) => {
          item.importe_destinado = 0
        })
      } else {
        this.tablaComprobantes.seleccionados = this.tablaComprobantes.items.slice()
        _.forEach(this.tablaComprobantes.seleccionados, (item) => {
          this.asignarImporteDestinado(item, true)
        })
      }
    }

  }

}
</script>

<style lang="scss">
.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.v-messages__message {
  text-align: right;
}
</style>
